<template>
  <v-card
    class="login-dialog__content"
    :class="layout == 'portal' ? 'fixit-background-gradient' : ''"
    :style="!$vuetify.breakpoint.smAndDown ? 'height: 600px;' : ''"
  >
    <div
      class="login-dialog__content-container justify-center"
      style="height: 100%"
      :class="layout == 'portal' ? '' : 'justify-center'"
    >
      <div class="d-flex justify-center mb-10">
        <v-progress-circular
          class="login-dialog__content-container--loader"
          v-if="true"
          color="var(--v-primary-base)"
          indeterminate
          size="82"
        ></v-progress-circular>
      </div>
      <div>
        <p class="display-2">Velkommen!</p>
        <p class="headline">
          Du sendes nå tilbake til siden du var på ved innlogging
        </p>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "the-redirect-loader",
  props: {
    returnUrl: {
      required: false,
      default: "",
    },
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    formattedUrl() {
      var a = document.createElement("a");
      a.href = this.returnUrl;
      return a.hostname;
    },
  },
};
</script>
<style lang="scss">
@import "../../../assets/styles/login.scss";
</style>
